import React from 'react'
import StaticsProducePage from "../statics-produce/StaticsProducePage"
import StaticsCreatedPage from "../statics-created/StaticsCreatedPage"
import StaticsOvertime from "../statics-overtime/StaticsOvertime"
import store from 'store'
import StaticsAveragePage from "../statics-average/StaticsAveragePage";
import StaticsCutoffPage from '../statics-cutoff/StaticsCutoffPage'
import StaticsOrderHourPage from '../statics-order-hour/StaticsOrderHourPage'
import ForecastShipBatchPage from '../forecast-ship-batch/ForecastShipBatchPage'
import OperationsReportContainer from '../operations-report/OperationsReportContainer'
import {updateWindowLocation} from '../../helpers/windowURI'

class StatisticsViewV2 extends React.Component {
    state = {
        activeTab: store.get('activeTab') || 'overtime'
    }

    _onChangeTabActive = (active) => {
        this.setState({
            activeTab: active
        }, () => {
            store.set('activeTab', this.state.activeTab)
            updateWindowLocation({})
        })
    }

    render() {
        const {activeTab} = this.state

        const tabContent = {
            overtime: <StaticsOvertime/>,
            produce: <StaticsProducePage/>,
            created: <StaticsCreatedPage/>,
            average: <StaticsAveragePage/>,
            cutoff: <StaticsCutoffPage/>,
            order_hour : <StaticsOrderHourPage/>,
            forecast_ship_batch : <ForecastShipBatchPage/>,
            operations_report : <OperationsReportContainer/>
        }

        return (
            <div className='StatisticsView'>
                <div className="page-title">
                    <h1 className="mb-0 font-weight-black">Hệ thống quản trị KTS MCVN</h1>
                </div>

                <div className='TabHead'>
                    <ul className='TabFilter'>
                        <li
                            className={`${activeTab === 'overtime' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('overtime')}
                        >
                            Thống kê quá hạn
                        </li>
                        <li
                            className={`${activeTab === 'produce' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('produce')}
                        >
                            Thống kê sản xuất
                        </li>
                        <li
                            className={`${activeTab === 'created' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('created')}
                        >
                            Thống kê số lượng hàng hóa theo thời gian
                        </li>
                        <li
                            className={`${activeTab === 'average' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('average')}
                        >
                            Thống kê thời gian sản xuất
                        </li>
                        <li
                            className={`${activeTab === 'cutoff' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('cutoff')}
                        >
                            Thống kê cutoff
                        </li>
                        <li
                            className={`${activeTab === 'order_hour' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('order_hour')}
                        >
                            Thống kê đơn theo giờ
                        </li>
                        <li
                            className={`${activeTab === 'forecast_ship_batch' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('forecast_ship_batch')}
                        >
                            Khối lượng ship
                        </li>
                        <li
                            className={`${activeTab === 'operations_report' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('operations_report')}
                        >
                            Báo cáo vận hành
                        </li>
                    </ul>
                </div>

                <div className='tabContent'>
                    {tabContent[activeTab]}
                </div>
            </div>
        )
    }
}

export default StatisticsViewV2
